import script from "./Bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./Bottom.vue?vue&type=script&setup=true&lang=js"

import "./Bottom.vue?vue&type=style&index=0&id=449f6f18&lang=scss&scoped=true"

import exportComponent from "/Users/yq-qianduan/Documents/yq-home-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-449f6f18"]])

export default __exports__